import React from "react";
import { NavbarRow } from "./navbar";

export const Header = ({ isToggled, handleToggle }) => {
  return (
    <React.Fragment>
      <div className="header-sec">
        <NavbarRow />
      </div>
    </React.Fragment>
  );
};
